import { graphql } from "gatsby";
import React from "react";
import { Colours } from "../../../utils/colours";
import WrappedSection, {
	UnwrappedWrappedSection,
} from "../../WrappedSection/WrappedSection";
import * as styles from "./ParagraphText.module.scss";

export interface ParagraphTextProps {
	htmlText?: string;
	isSubSection?: boolean;
}

export const getParagraphTextProps = ({
	field_text,
}: Queries.ParagraphTextDataFragment) => ({
	htmlText: field_text.value,
});
export const ParagraphText: React.FC<ParagraphTextProps> = ({
	htmlText,
	isSubSection = false,
}) => {
	const Wrapper = isSubSection ? UnwrappedWrappedSection : WrappedSection;
	return (
		<Wrapper sectionName="ParagraphText" sectionColour={Colours.WHITE}>
			<div
				className={styles.text}
				// biome-ignore lint/security/noDangerouslySetInnerHtml: Safe source
				dangerouslySetInnerHTML={{
					__html: htmlText,
				}}
			/>
		</Wrapper>
	);
};

export default ParagraphText;

export const fragment = graphql`
    fragment ParagraphTextData on paragraph__text {
        __typename
        id
        field_text {
            value
        }
    }
`;
